import { h, render } from "preact";
import { App } from "./app/index.js";
import { StoreProvider } from "@jaybeeuu/preact-recoilless";

if (process.env.NODE_ENV === "development") {
  void import("preact/debug");
}

const appSelector = "#app";
const app = document.querySelector(appSelector);

if (!app) {
  throw new Error(`Unable to start app; missing element "${appSelector}"."`);
}

render(
  <StoreProvider>
    <App />
  </StoreProvider>,
  app,
);
